module.exports = __webpack_public_path__ + "assets/img/phone.4b7b88de.png";